export const getFiltersArray = (
  filterNames: string[],
  filters: Record<string, string | undefined>,
  setFilter: (filterName: string, value: string | undefined) => void,
) => {
  return filterNames
    .map((filterName) => ({
      key: filterName,
      value: filters[filterName],
      setValue: (value: string | undefined) => setFilter(filterName, value),
    }))
    .filter((filter) => filter.value !== undefined);
};
